<template>
  <div>
    <div class="title">
      <h3>Demandes de validation</h3>
    </div>

    <hr>

    <div>
      <table v-if="selectedRequests.length > 0"
        class="table table-hover table-condensed table-detailed table-borderless table-striped search-table">
        <tbody>
          <tr v-for="(validationRequest, idx) in selectedRequests"
              :key="'validation-request-'+idx">
            <td class="v-align-middle">{{ validationRequest.included.type.attributes.display_name }}</td>
            <td class="v-align-middle">{{ validationRequest.attributes.created_at | moment-date }}</td>
            <td class="v-align-middle">
              <router-link :to="{ name: 'single-demand', params: { id: validationRequest.id } }">
                <span>
                  <i class="circle-arrow"></i>
                  {{ getEnumTranslatedValue('validation_request_status', validationRequest.attributes.status)}}
                </span>
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-else class="alert alert-info">
        Aucune demande en attente de validation
      </div>
    </div>

    <div class="clearfix">
      <button class="btn btn-complete pull-right" @click="switchToValidationRequestsList">
        Voir tous
      </button>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    name: "ValidationRequests",

    methods: {
      ...mapActions('customerV2', ['getCustomerValidationRequests']),

      switchToValidationRequestsList() {
        this.$root.$emit('active-tab-updated', {
          storeModule: 'customer',
          target: 'validation-requests'
        })
      },
    },

    computed: {
      ...mapState('customerV2', ['validationRequests']),

      selectedRequests() {
        if (this.validationRequests && this.validationRequests.hasOwnProperty('data')) {
          return this.validationRequests.data.slice(0, 5)
        }

        return []
      }
    },

    created () {
      let params = {
        customerId: this.$route.params.id,
        filter: {
          is_parent: 1,
          status: "pending"
        }, 
        with: "type"
      }

      this.getCustomerValidationRequests(params)
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/ValidationRequests.vue